<template>
  <BaseCard :title="'Climbing Hold Classifier'" :highlightLastWord="false">
    <div class="flex flex-col justify-center gap-4">
      <div class="w-full grid lg:grid-cols-2 lg:gap-20">
        <h5 class="lg:justify-self-end lg:pr-6 font-medium">Solo Engineer</h5>
        <h5 class="lg:justify-self-start lg:pl-6 font-medium">January 2026 - Present</h5>
      </div>

      <p class="text-center items-center px-4 gap-2">
        <span class="block">
          5-stage Computer Vision pipeline for classifying climbing holds in images into 7 classes
        </span>
        <span class="block">
          Utilizes YOLO11n object detection, CLAHE normalization, SAM segmentation, ResNet-18 CNN feature extraction, & RBF-kernel SVM classification
        </span>
        <span class="block">
          Collected & labeled 2000 climbing hold images from Notre Dame's climbing wall for training, validating, & testing
        </span>
        <span class="block">
          Achieved 80.2% test accuracy after comparing 8 pipeline architectures
        </span>
        <a href="https://github.com/cgreen2048/Climbing-Hold-Classifier" target="_blank" class="photo-link"
        >
            View my 
            <span class="link-in-text">
                Github Repo
            </span>
        </a>
    </p>
    <span class="flex flex-col place-items-center overflow-hidden">
        <img class="w-[50%] h-auto rounded-lg cursor-pointer"  :src="JugClass" @click="openImageMenu(JugClass, 'Jug Class Screenshot', $event.currentTarget)">
    </span>
    </div>
  </BaseCard>
</template>

<script lang="ts" setup>
import BaseCard from '@/features/global/BaseCard.vue';
import JugClass from '@/assets/Projects/ClimbingHoldClassifierPhotos/JugClass.jpg';
import { useImageViewer } from '@/features/composables/useImageViewer';

const { openImageMenu } = useImageViewer();
</script>